import { IconPlayStroke as b, CdrImg as f } from "@rei/cedar";
import h from "@rei/ambient-video-player";
import { resolveComponent as d, openBlock as i, createElementBlock as c, normalizeStyle as g, createElementVNode as n, createCommentVNode as s, normalizeClass as P, createVNode as y, createBlock as V, withModifiers as v, toDisplayString as I } from "vue";
const k = (t, r) => {
  const e = t.__vccOpts || t;
  for (const [a, l] of r)
    e[a] = l;
  return e;
}, w = {
  name: "YouTubeVideoPlayer",
  components: {
    IconPlayStroke: b,
    CdrImg: f,
    AmbientVideoPlayer: h
  },
  props: {
    videoId: {
      type: String,
      required: !0,
      default: null
    },
    playButtonLabel: {
      type: String,
      default: "Play Video"
    },
    reduceMotion: {
      type: Boolean,
      default: !1
    },
    poster: {
      type: Object,
      default() {
        return {};
      }
    },
    ambientVideoUrl: {
      type: String,
      default: null
    },
    ratio: {
      type: String,
      default: "16-9"
    },
    autoplay: {
      type: Boolean,
      default: !1,
      required: !1
    }
  },
  data() {
    return {
      renderPlayer: !1
    };
  },
  computed: {
    youTubeUrl() {
      return this.videoId && `https://www.youtube-nocookie.com/embed/${this.videoId}?autoplay=${this.autoplayValue}` || null;
    },
    renderPosterImg() {
      var t;
      return ((t = this.poster) == null ? void 0 : t.src) && !this.ambientVideoUrl;
    },
    ratioCssVariable() {
      let t = 0.5625;
      if (/^(?:\d+)(?:-)(?:\d+)/gm.test(this.ratio)) {
        const [e, a] = this.ratio.split("-");
        t = parseInt(a, 10) / parseInt(e, 10);
      }
      return `--ambient-video-ratio: ${t};`;
    },
    autoplayValue() {
      return this.renderPosterImg || this.ambientVideoUrl || this.autoplay ? 1 : 0;
    }
  },
  mounted() {
    !this.renderPosterImg && !this.ambientVideoUrl && this.$nextTick(() => {
      this.loadPlayer();
    });
  },
  methods: {
    onIframeLoaded() {
      this.$refs.youtubeFrame.contentWindow.focus();
    },
    async loadPlayer() {
      this.renderPlayer = !0;
    }
  }
}, U = {
  class: "youtube-player__wrapper"
}, x = ["src"], B = {
  key: 0,
  class: "youtube-player__poster-picture"
}, C = {
  class: "sr-only"
};
function S(t, r, e, a, l, o) {
  const m = d("cdr-img"), p = d("ambient-video-player"), _ = d("icon-play-stroke");
  return e.videoId ? (i(), c("div", {
    key: 0,
    style: g(o.ratioCssVariable),
    class: "youtube-player"
  }, [n("div", U, [l.renderPlayer ? (i(), c("iframe", {
    key: 0,
    ref: "youtubeFrame",
    src: o.youTubeUrl,
    "aria-label": "YouTube Video Player",
    class: "youtube-player__iframe",
    frameborder: "0",
    allow: "accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture",
    allowfullscreen: "",
    onLoad: r[0] || (r[0] = (...u) => o.onIframeLoaded && o.onIframeLoaded(...u))
  }, null, 40, x)) : s("", !0)]), n("div", {
    class: P(["youtube-player__poster", {
      "youtube-player__poster--hide": l.renderPlayer
    }])
  }, [o.renderPosterImg ? (i(), c("picture", B, [y(m, {
    alt: e.poster.alt,
    src: e.poster.src,
    fit: t.cover,
    loading: "lazy",
    "aria-hidden": "true"
  }, null, 8, ["alt", "src", "fit"])])) : s("", !0), e.ambientVideoUrl ? (i(), V(p, {
    key: 1,
    src: e.ambientVideoUrl,
    "hide-controls": !0,
    "reduce-motion": e.reduceMotion,
    ratio: e.ratio
  }, null, 8, ["src", "reduce-motion", "ratio"])) : s("", !0), n("button", {
    class: "youtube-player__poster-button",
    tabindex: "0",
    onClick: r[1] || (r[1] = v((...u) => o.loadPlayer && o.loadPlayer(...u), ["prevent"]))
  }, [n("span", C, I(e.playButtonLabel), 1), y(_, {
    class: "youtube-player__button-icon"
  })])], 2)], 4)) : s("", !0);
}
const z = /* @__PURE__ */ k(w, [["render", S]]);
export {
  z as default
};
